import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { BaseService } from 'src/app/core/services/base.service';
import { DataImportConfig2 } from '../models/data-import-2-config';

@Component({
  selector: 'optsol-ngx-data-import-dialog-2',
  templateUrl: './data-import-dialog-2.component.html',
  styleUrls: ['./data-import-dialog-2.component.scss']
})
export class DataImportDialogComponent2 implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicFormComponent;
  @ViewChild('parent') elementView: ElementRef;

  tableConfig: any;
  tableData: any;
  tableHeight: any;

  constructor(
    private baseService: BaseService,
    private dialogRef: MatDialogRef<DataImportDialogComponent2>,
    @Inject(MAT_DIALOG_DATA) public data: {
      config: DataImportConfig2
    }) { }

  async ngOnInit(): Promise<void> {
    this.baseService.executeCommand(this.data.config.tableConfigProc, {})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.tableConfig = response.data;
        }
      });
      this.dialogRef.updateSize('600px');
  }

  ngAfterViewInit() {
    this.tableHeight = window.innerHeight - 250;//this.elementView.nativeElement.offsetHeight; //- 190; // The form being small causes the grid to be small
}

  submitted(event: any) {
    if (event.responseCode === 0) {
      this.dialogRef.close(event);
    }
  }

  // Change the size of the dialog based on which step we're on
  matStepperSelectionChange(event: any) {
    if (event.selectedIndex === 0) this.dialogRef.updateSize('600px');
    else if (event.selectedIndex === 1) {
      this.dialogRef.updateSize('90%');
    }
    else if (event.selectedIndex === 2) this.dialogRef.updateSize('600px');
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
